/* Picardo 2026-10-18: skróty do edytora, pasek narzędzi (Cofnij, Rozdziel, Gumka, Usuń), przycisk Zdjęcie. */
(function () {
  if (window.__pcUx) return; window.__pcUx = true;
  var DESIGN_URL = '/products/tort-jak-z-cukierni';
  var ICON_PHOTO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h3l1.5-2h7L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.2"/></svg>';

  function tuneEditor(ed) {
    if (ed.getAttribute('data-pc-ux')) return;
    ed.setAttribute('data-pc-ux', '1');
    var main = ed.querySelector('.pc-ed__main'), stage = main && main.querySelector('.pc-ed__stage');
    if (main && stage) {
      var hint = document.createElement('p'); hint.className = 'pc-ed__hint';
      hint.textContent = 'Dodaj zdjęcie, grafikę albo napis z paska na dole. Gdy projekt jest gotowy, kliknij Zamów.';
      main.insertBefore(hint, stage);
      var bar = document.createElement('div'); bar.className = 'pc-ed__bar'; bar.setAttribute('role', 'toolbar'); bar.setAttribute('aria-label', 'Narzędzia projektu');
      bar.innerHTML = '<button type="button" data-pc-act="undo" disabled>Cofnij</button>' +
        '<button type="button" data-pc-act="redo" disabled>Ponów</button>' +
        '<button type="button" data-pc-act="split" disabled title="Rozdziela zlepioną grafikę na osobne części">Rozdziel</button>' +
        '<button type="button" data-pc-act="erase" aria-pressed="false" disabled title="Wymazuje fragment zaznaczonej grafiki">Gumka</button>' +
        '<button type="button" data-pc-act="delete" class="pc-ed__bar-del" disabled>Usuń</button>' +
        '<button type="button" class="pc-ed__finish" data-pc-finish>Gotowe, zamawiam →</button>' +
        '<label class="pc-ed__brush" data-pc-brushbox hidden>Grubość <input type="range" min="1" max="14" value="4" data-pc-brush></label>';
      main.insertBefore(bar, stage);
    }
    // AI: dwa jasne wejścia w jednym panelu (inspiracja z tortu albo własne zdjęcie w motywie)
    var ai = ed.querySelector('[data-pc-panel="ai"]'), pa = ed.querySelector('[data-pc-photoai]'), pb = ed.querySelector('[data-pc-photoai-open]');
    if (ai && pa) {
      if (pb) pb.hidden = true;
      var all = document.createElement('button'); all.type = 'button'; all.className = 'pc-ed__aiall'; all.setAttribute('data-pc-aiall', ''); all.textContent = 'Pokaż wszystkie opcje AI';
      ai.insertBefore(all, ai.children[1] || null);
      pa.hidden = false;
      var t1 = ai.querySelector('.pc-ed__ai-title'); if (t1) t1.textContent = '1. Wgraj inspirację: zdjęcie tortu, który Ci się podoba';
      var box = document.createElement('div'); box.className = 'pc-ed__ai pc-ed__ai2';
      var t2 = document.createElement('strong'); t2.className = 'pc-ed__ai-title'; t2.textContent = '2. Albo przerób swoje zdjęcie w motyw z bajki';
      box.appendChild(t2); box.appendChild(pa); ai.appendChild(box);
    }
    // telefon: osobny, zawsze widoczny przycisk Zamawiam nad dolnym paskiem
    var pce = ed.classList.contains('pc-ed') ? ed : ed.querySelector('.pc-ed');
    if (pce && !pce.querySelector('.pc-ed__cta')) {
      var cta = document.createElement('button'); cta.type = 'button'; cta.className = 'pc-ed__cta'; cta.setAttribute('data-pc-finish', '');
      cta.textContent = 'Gotowe, zamawiam →'; pce.appendChild(cta);
    }
    // Dolny pasek: Zdjęcie jako pierwszy przycisk
    var dock = ed.querySelector('.pc-ed__dock');
    if (dock && !dock.querySelector('[data-pc-photo-btn]')) {
      var pbtn = document.createElement('button'); pbtn.type = 'button'; pbtn.setAttribute('data-pc-photo-btn', '');
      pbtn.innerHTML = ICON_PHOTO + 'Zdjęcie';
      dock.insertBefore(pbtn, dock.firstChild);
    }
  }


  // ---------- quiz na wejściu do edytora ----------
  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 899px)') : { matches: false };
  function zlp(v) { return (Math.round(+v) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function kindBtn(ed, sugar) {
    var all = ed.querySelectorAll('[data-pc-kind]'), found = null;
    all.forEach(function (b) { if (!found && /pap/i.test(b.getAttribute('data-name') || '') === sugar) found = b; });
    return found;
  }
  function goPanel(ed, name) {
    var cur = ed.querySelector('[data-pc-panel].is-active'), curName = cur && cur.getAttribute('data-pc-panel');
    if (name === curName) return;
    var tab = ed.querySelector('.pc-ed__dock [data-pc-tab="' + (name || curName) + '"]');
    if (tab) tab.click();
  }

  function closePanels(ed) {
    var x = ed.querySelector('[data-pc-panel].is-active [data-pc-panel-close]'); if (x) x.click();
  }
  // AI startuje samo po quizie, a na plotnie widac ekran ladowania
  function autoGen(ed, mode, A) {
    var foto = mode === 'foto';
    var form = ed.querySelector(foto ? '[data-pc-photoform]' : '[data-pc-aiform]'); if (!form) return;
    try {
      if (foto) { var th = ed.querySelector('[data-pc-photo-theme]'); if (th) th.value = A.theme; }
      else {
        var inp = ed.querySelector('[data-pc-ai-file]');
        var dt = new DataTransfer(); dt.items.add(A.tortFile); inp.files = dt.files;
      }
    } catch (er) { return; }
    var stage = ed.querySelector('.pc-ed__stage');
    var box = document.createElement('div'); box.className = 'pc-gen'; box.setAttribute('role', 'status');
    box.innerHTML = '<i class="pc-gen__spin"></i><strong>AI rysuje Twój wydruk</strong><span>To trwa zwykle do minuty. Nie zamykaj strony.</span>';
    if (stage) stage.appendChild(box);
    var btn = form.querySelector('button[type=submit]'), n = 0;
    if (form.requestSubmit) form.requestSubmit(); else if (btn) btn.click();
    var t = setInterval(function () {
      n++;
      if ((btn && !btn.disabled && n > 2) || n > 400) { clearInterval(t); if (box.parentNode) box.parentNode.removeChild(box); }
    }, 500);
  }

  // własny gotowy projekt: wchodzi na płótno jako podgląd i od razu otwiera się zamówienie
  function loadOwn(ed, f) {
    try {
      var inp = ed.querySelector('[data-pc-upload]'); if (!inp) return;
      var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (er) { return; }
    var n = 0, t = setInterval(function () {
      n++;
      if (ed.classList.contains('has-layers')) {
        clearInterval(t);
        if (MOBILE.matches) { closePanels(ed); goPanel(ed, 'zamow'); }
        else { var lay = ed.querySelector('[data-pc-layout]'); if (lay) lay.classList.add('is-libhidden'); var pz = ed.querySelector('[data-pc-panel="zamow"]'); if (pz) pz.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      } else if (n > 40) clearInterval(t);
    }, 150);
  }

  // data imprezy: realizacja trwa 2 dni, dzisiaj i jutro dostają ostrzeżenie zamiast cichego blokowania
  function isoOf(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function minDay() { var m = new Date(); m.setDate(m.getDate() + 2); return isoOf(m); }
  function dateInputs() { return document.querySelectorAll('[data-pc-date], [data-pc-ed-date]'); }
  function freeMin() { dateInputs().forEach(function (i) { i.removeAttribute('min'); }); }
  function tooSoon(i) { return !!(i && i.value && i.value < minDay()); }
  function warnDate(i) {
    var w = i.__pcw;
    if (!w) { w = i.__pcw = document.createElement('p'); w.setAttribute('role', 'alert'); w.style.cssText = 'margin:6px 0 0;padding:8px 10px;border-radius:8px;background:#fff0f0;color:#b3261e;font-size:14px;line-height:1.35'; i.parentNode.insertBefore(w, i.nextSibling); }
    if (tooSoon(i)) {
      w.textContent = 'Realizacja trwa 2 dni, więc przy tej dacie wydruk nie dotrze do Ciebie na czas. Najwcześniejszy termin to ' + minDay().split('-').reverse().join('.') + '. Wybierz późniejszą datę albo napisz do nas na WhatsApp.';
      w.hidden = false;
    } else w.hidden = true;
    return tooSoon(i);
  }
  document.addEventListener('change', function (e) { var t = e.target; if (t.matches && t.matches('[data-pc-date], [data-pc-ed-date]')) warnDate(t); }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pc-addcart], [data-pc-sticky-buy], [data-pc-submit], [data-pc-rbuy], [data-pc-copy-yes], [data-pc-copy-no], [data-pc-rcopy-yes], [data-pc-rcopy-no]');
    if (!b) return;
    var edr = b.closest('[data-pc-editor]'), i;
    if (edr) i = edr.querySelector('[data-pc-ed-date]');
    else if (b.matches('[data-pc-rbuy], [data-pc-rcopy-yes], [data-pc-rcopy-no]')) i = document.querySelector('[data-pc-rdate]');
    else i = document.querySelector('[data-pc-form] [data-pc-date]');
    if (i && warnDate(i)) { e.preventDefault(); e.stopImmediatePropagation(); i.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }, true);
  document.addEventListener('submit', function (e) {
    var i = e.target.matches && e.target.matches('[data-pc-form]') ? e.target.querySelector('[data-pc-date]') : null;
    if (i && warnDate(i)) { e.preventDefault(); e.stopImmediatePropagation(); i.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }, true);
  freeMin(); document.addEventListener('DOMContentLoaded', freeMin); window.addEventListener('load', function () { freeMin(); setTimeout(freeMin, 500); });

  function startQuiz(ed) {
    if (ed.getAttribute('data-pc-quiz') || ed.classList.contains('has-layers')) return;
    ed.setAttribute('data-pc-quiz', 'on');
    var A = { own: false, ownFile: null, photo: false, tort: false, motyw: false, file: null }, step = 0, pending = null;
    var ov = document.createElement('div'); ov.className = 'pc-quiz'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-label', 'Zaprojektuj wydruk krok po kroku');
    ed.appendChild(ov);

    function card(label, sub, fn, cls) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pc-quiz__card' + (cls ? ' ' + cls : '');
      b.innerHTML = '<strong></strong>' + (sub ? '<small></small>' : '');
      b.firstChild.textContent = label; if (sub) b.lastChild.textContent = sub;
      b.addEventListener('click', fn); return b;
    }
    function show(n, title, lead, body, backTo) {
      step = n;
      ov.innerHTML = '';
      var top = document.createElement('div'); top.className = 'pc-quiz__top';
      var dots = document.createElement('span'); dots.className = 'pc-quiz__dots';
      for (var i = 1; i <= 6; i++) { var d = document.createElement('i'); if (i <= n + 1) d.className = 'is-on'; dots.appendChild(d); }
      top.appendChild(dots);
      var skip = document.createElement('button'); skip.type = 'button'; skip.className = 'pc-quiz__skip'; skip.textContent = 'Pomiń pytania';
      skip.addEventListener('click', function () { finish(true); }); top.appendChild(skip);
      ov.appendChild(top);
      var h = document.createElement('h2'); h.textContent = title; ov.appendChild(h);
      if (lead) { var p = document.createElement('p'); p.className = 'pc-quiz__lead'; p.textContent = lead; ov.appendChild(p); }
      var box = document.createElement('div'); box.className = 'pc-quiz__opts'; body.forEach(function (x) { box.appendChild(x); }); ov.appendChild(box);
      if (n >= 1) {
        var back = document.createElement('button'); back.type = 'button'; back.className = 'pc-quiz__back'; back.textContent = '← Wstecz';
        back.addEventListener('click', function () { go(backTo || n - 1); }); ov.appendChild(back);
      }
    }
    function priceOf(sugar) { var b = kindBtn(ed, sugar); return b ? 'od ' + zlp(b.getAttribute('data-price')) : ''; }

    function go(n) {
      if (n === 0) show(0, 'Masz już gotowy projekt do wydruku?', 'Np. grafikę z komputera lub od grafika. Wgrasz ją i od razu zobaczysz podgląd przed zamówieniem.', [
        card('Tak, mam gotowy projekt', 'wgram plik i przejdę do zamówienia', function () { A.own = true; go(1); }, 'is-main'),
        card('Nie, zaprojektuję wydruk', 'poprowadzimy Cię krok po kroku', function () { A.own = false; go(1); })
      ]);
      else if (n === 1) show(1, 'Jaki kształt ma mieć wydruk?', 'Wybierz, a resztę ustawimy za Ciebie.', [
        card('Koło 20 cm', 'na okrągły tort', function () { pick('[data-pc-shape="circle"]'); go(2); }),
        card('Prostokąt A4', 'na blachę, kilka motywów obok siebie', function () { pick('[data-pc-shape="a4"]'); go(2); })
      ]);
      else if (n === 2) show(2, 'Na czym wydrukować?', 'Cenę widzisz od razu, podamy ją też przy zamówieniu.', [
        card('Opłatek', priceOf(false), function () { var k = kindBtn(ed, false); if (k) k.click(); go(A.own ? 7 : 3); }),
        card('Papier cukrowy / skrobiowy', priceOf(true), function () { var k = kindBtn(ed, true); if (k) k.click(); go(A.own ? 7 : 3); })
      ]);
      else if (n === 3) show(3, 'Chcesz wgrać własne zdjęcie?', 'Np. dziecka, pupila albo zdjęcie z telefonu.', [
        card('Tak, wgram zdjęcie', 'wybierzesz je z telefonu lub komputera', function () {
          var inp = ed.querySelector('[data-pc-upload]'); if (!inp) return go(4);
          pending = 5; inp.click();
        }, 'is-main'),
        card('Nie, zacznę od zera', '', function () { A.photo = false; go(4); })
      ]);
      else if (n === 4) show(4, 'Zaprojektować wydruk na podstawie zdjęcia tortu?', 'AI przerysuje elementy z tortu, który Ci się podoba (bez napisów, imię dodasz w edytorze).', [
        card('Tak, mam zdjęcie tortu', 'wgrasz je za chwilę', function () { go(6); }, 'is-main'),
        card('Nie, dziękuję', '', function () { A.tort = false; finish(false); })
      ]);
      else if (n === 7) {
        var lab7 = document.createElement('label'); lab7.className = 'pc-quiz__card pc-quiz__drop is-main';
        lab7.innerHTML = '<strong>Wybierz plik z projektem</strong><small>JPG, PNG albo WebP. Zaraz zobaczysz podgląd.</small><input type="file" accept="image/*" hidden>';
        lab7.querySelector('input').addEventListener('change', function (e) {
          var f = e.target.files && e.target.files[0]; if (!f) return;
          A.ownFile = f; finish(false);
        });
        show(2, 'Wgraj swój projekt', 'Wydruk będzie dokładnie taki, jaki zobaczysz w podglądzie.', [lab7], 2);
      }
      else if (n === 6) {
        var lab = document.createElement('label'); lab.className = 'pc-quiz__card pc-quiz__drop is-main';
        lab.innerHTML = '<strong>Wybierz zdjęcie tortu</strong><small>AI od razu zacznie rysować wydruk</small><input type="file" accept="image/*" hidden>';
        lab.querySelector('input').addEventListener('change', function (e) {
          var f = e.target.files && e.target.files[0]; if (!f) return;
          A.tort = true; A.tortFile = f; finish(false);
        });
        show(4, 'Wgraj zdjęcie tortu', 'Najlepiej takiego, z którego chcesz wziąć motywy.', [lab], 4);
      }
      else if (n === 5) {
        var inp = document.createElement('input'); inp.className = 'pc-input pc-quiz__theme'; inp.type = 'text'; inp.maxLength = 120;
        inp.placeholder = 'Motyw, np. Psi Patrol, piłka nożna, jednorożce, kwiaty'; inp.setAttribute('aria-label', 'Motyw');
        var chips = document.createElement('div'); chips.className = 'pc-quiz__chips';
        ['Bajka', 'Superbohater', 'Piłka nożna', 'Gry', 'Księżniczka', 'Komiks', 'Akwarela', 'Retro', 'Wesele, rocznica', 'Zwierzęta', 'Kwiaty'].forEach(function (t) {
          var c = document.createElement('button'); c.type = 'button'; c.textContent = t; c.addEventListener('click', function () { inp.value = t; }); chips.appendChild(c);
        });
        var yes = card('Tak, zrób z mojego zdjęcia grafikę', 'AI narysuje Cię w motywie, który wpiszesz wyżej', function () {
          if (!inp.value.trim()) { inp.focus(); inp.classList.add('is-err'); return; }
          A.motyw = true; A.theme = inp.value.trim(); finish(false);
        }, 'is-main');
        var no = card('Nie, zostaw moje zdjęcie', '', function () { A.motyw = false; finish(false); });
        show(5, 'Chcesz, żeby AI zrobiło z Twojego zdjęcia grafikę w wybranym motywie?', 'Motyw może być dowolny. AI nie dodaje napisów, te dodasz sam w edytorze.', [inp, chips, yes, no], 3);
      } else finish(false);
    }
    function pick(sel) { var b = ed.querySelector(sel); if (b) b.click(); }

    // zdjęcie wybrane w kroku 3: kopiujemy je też do formularza AI, żeby nie wybierać drugi raz
    function onUpload(e) {
      if (!e.target.matches || !e.target.matches('[data-pc-upload]') || ed.getAttribute('data-pc-quiz') !== 'on') return;
      var f = e.target.files && e.target.files[0]; if (!f) return;
      A.photo = true; A.file = f;
      try {
        var dt = new DataTransfer(); dt.items.add(f);
        var pf = ed.querySelector('[data-pc-photo-file]'); if (pf) { pf.files = dt.files; }
      } catch (er) {}
      if (pending) { var nx = pending; pending = null; setTimeout(function () { go(nx); }, 200); }
    }
    ed.addEventListener('change', onUpload, true);

    function finish(skipped) {
      ed.removeEventListener('change', onUpload, true);
      ed.setAttribute('data-pc-quiz', 'done');
      if (ov.parentNode) ov.parentNode.removeChild(ov);
      if (A.own && A.ownFile && !skipped) { ed.removeAttribute('data-pc-aimode'); loadOwn(ed, A.ownFile); return; }
      var mode = A.tort ? 'tort' : A.motyw ? 'foto' : '';
      if (mode) ed.setAttribute('data-pc-aimode', mode); else ed.removeAttribute('data-pc-aimode');
      if (MOBILE.matches) closePanels(ed); // biblioteka grafik otwiera się dopiero z paska na dole
      if (skipped) return;
      else if (mode) { var lay = ed.querySelector('[data-pc-layout]'); if (lay) lay.classList.add('is-libhidden'); }
      if (mode) autoGen(ed, mode, A);
    }
    go(0);
  }

  function watchOpen() {
    document.querySelectorAll('[data-pc-editor]').forEach(function (ed) {
      if (ed.__pcw) return; ed.__pcw = true;
      new MutationObserver(function () {
        if (ed.classList.contains('is-open')) startQuiz(ed);
      }).observe(ed, { attributes: true, attributeFilter: ['class'] });
    });
  }
  // gotowy projekt ładuje się bez pytań
  document.addEventListener('click', function (e) {
    var ld = e.target.closest && e.target.closest('[data-pc-load-design]');
    if (ld) { var ed = document.querySelector('[data-pc-editor]'); if (ed) ed.setAttribute('data-pc-quiz', 'done'); }
    var fin = e.target.closest && e.target.closest('[data-pc-finish]');
    if (fin) {
      var ed2 = fin.closest('[data-pc-editor]'), z = ed2 && ed2.querySelector('.pc-ed__dock [data-pc-tab="zamow"]');
      if (z) { if (MOBILE.matches) goPanel(ed2, 'zamow'); else { var lay = ed2.querySelector('[data-pc-layout]'); if (lay) lay.classList.add('is-libhidden'); var pz = ed2.querySelector('[data-pc-panel="zamow"]'); if (pz) pz.scrollIntoView({ block: 'center', behavior: 'smooth' }); } }
    }
    var all = e.target.closest && e.target.closest('[data-pc-aiall]');
    if (all) { var ed3 = all.closest('[data-pc-editor]'); if (ed3) ed3.removeAttribute('data-pc-aimode'); }
  }, true);

  function init() {
    document.querySelectorAll('a.pc-pin, .pc-nav__links a').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if ((a.classList.contains('pc-pin') || h.indexOf(DESIGN_URL) === 0) && h.indexOf('#') < 0) a.setAttribute('href', h + '#edytor');
    });
    document.querySelectorAll('[data-pc-editor]').forEach(tuneEditor);
    watchOpen();
    document.querySelectorAll('[data-pc-editor].is-open').forEach(startQuiz);
    if (location.hash === '#edytor') {
      var btn = document.querySelector('[data-pc-open-editor]');
      if (btn) setTimeout(function () { btn.click(); }, 150);
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pc-photo-btn]'); if (!b) return;
    var ed = b.closest('[data-pc-editor]'), inp = ed && ed.querySelector('[data-pc-upload]');
    if (inp) inp.click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
